import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/support.svg'


const _hoisted_1 = { class: "bg-white border-round mr-4 align-self-start mb-4 flex h-full" }
const _hoisted_2 = { class: "p-3 flex flex-column" }

import { onBeforeMount } from 'vue';
import { useAuthStore } from '@/store';
import { useBeacon } from '@/composables/HelpScoutWidget';


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportWidget',
  setup(__props) {

const authStore = useAuthStore();
const user = authStore.user;
onBeforeMount(() => {
  useBeacon(user);
});
const openBeacon = () => window.Beacon('toggle');

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "flex align-items-center mb-3" }, [
        _createElementVNode("span", {
          class: "material-icons mr-2",
          style: {"color":"#8bcfcf"}
        }, "help"),
        _createTextVNode(" Need Help? ")
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        class: "w-12rem flex-1 pb-3"
      }, null, -1)),
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Chat With Support",
        "full-width": "",
        onClick: openBeacon
      })
    ])
  ]))
}
}

})